import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import App from "./App";
import "./index.css";
import configureStore from "./store/Configurstore";

// Import the configured store and persistor
const { store, persistor } = configureStore();

if (process.env.NODE_ENV !== "development") {
  console.log = () => { };
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<div className="ripple"></div>} persistor={persistor}>
        <Suspense fallback={<div className="ripple"></div>}>
          <App />
        </Suspense>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);


